<template>
  <div class="UploadLi">
    <div class="UploadLeft">
      <img
        class="icon"
        :src="icon"
        alt=""
      >
      <div class="nameBox">
        <div class="name">{{nameText}}</div>
        <div class="nameTip">{{nameTip}}</div>
      </div>
    </div>
    <div
      class="upload"
      @click="upload"
    >
      去采集
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  name: 'UploadLi',
  props: ['icon', 'nameText', 'nameTip'],
  data() {
    return {};
  },
  methods: {
    upload() {
      if (this.$attrs.collectCode === '1') {
        Toast('数据上传中，请勿重复操作');
        return;
      }
      this.$emit('upload');
    },
  },
};
</script>
<style lang="scss" scoped>
.UploadLi {
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
}
.upload {
  width: 74px;
  height: 28px;
  background: #fff;
  border-radius: 4px;
  margin-top: 12px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border: 1px solid #ff6538;
  font-family: PingFangSC-Regular;
  color: #ff6538;
  text-align: center;
  box-sizing: border-box;
}
.UploadLeft {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.nameTip {
  font-size: 12px;
  color: #b8c4cc;
  margin-top: 4px;
}
.name {
  font-size: 15px;
  color: #505659;
}
.icon {
  width: 60px;
  height: 60px;
  line-height: 60px;
  margin-top: 24px;
  margin-bottom: 12px;
}
</style>
